class SectionTabbedContent extends HTMLElement {
  constructor() {
    super();

    this.main = this.querySelector("[data-carousel]");
    this.nav = this.querySelector("[data-nav-carousel]");

    this.carouselMain = null;
    this.carouselNav = null;

    window.loadSwiper.then((swiperLib) => {
      this.swiperLib = swiperLib;
      this.init();
    });

    this.addEventListener("click", (e) => {
      if (!e.target.closest("[data-next]")) return;

      if (this.carouselMain) {
        this.carouselMain.slideNext();
      }
    });
  }

  init() {
    const { Swiper, Thumbs, EffectFade } = this.swiperLib;

    this.carouselNav = new Swiper(this.nav, {
      slidesPerView: "auto",
      centerInsufficientSlides: true,
      centeredSlidesBounds: true,
      centeredSlides: true,
    });

    this.carouselMain = new Swiper(this.main, {
      modules: [Thumbs, EffectFade],
      slidesPerView: 1,
      effect: "fade",
      fadeEffect: { crossFade: true },
      thumbs: {
        swiper: this.carouselNav,
        autoScrollOffset: 1,
      },
      loop: true,
    });
  }
}

if (!customElements.get("section-tabbed-content")) {
  customElements.define("section-tabbed-content", SectionTabbedContent);
}
